import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const LocalMatterLockedDialog = ({ open, onOpenChange, division }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md bg-[#FDFBF7] border-[#D8D2C4]" data-testid="local-matter-locked-dialog">
      <DialogHeader>
        <div className="w-11 h-11 rounded-full bg-[#1B2A41] text-[#FDFBF7] flex items-center justify-center mb-2"><ShieldCheck className="w-5 h-5" /></div>
        <DialogTitle className="font-type text-base md:text-lg text-[#1B2A41]">Local matters need committee approval</DialogTitle>
        <DialogDescription className="text-sm text-[#5C6A79] leading-relaxed pt-1">
          Any local matter must be approved by the F.E.R.M committee for {division ? `the Division of ${division}` : "your district"} before it can be added to a letter. This ensures trolls and bots do not diminish our work or our representation.
        </DialogDescription>
      </DialogHeader>
      <p className="text-xs text-[#5C6A79]">Raise it at your next group meeting. Once approved, it can be added to letters from your electorate.</p>
      <button type="button" onClick={() => onOpenChange(false)} data-testid="local-matter-locked-close" className="mt-2 h-10 px-5 rounded-full bg-[#1B2A41] hover:bg-[#2C3E55] text-[#FDFBF7] text-xs font-type font-bold uppercase tracking-wider self-start">Understood</button>
    </DialogContent>
  </Dialog>
);
